import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ChangePasswordApi from "./apihook/ChangePasswordApi";
import ToastMsg from "components/common/ToastMsg";
import { ImagePaths } from "utils/ImagePath";

const ResetPassword = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const authtoken = sessionStorage.getItem("token");
  const id = state ? parseInt(state.id) : 0;
  const user_name = state ? state.user_name : "";
  const email = state ? state.email : "";

  const onSubmit = () => {
    if (!newPassword || !confirmPassword) {
      ToastMsg("error", "Please fill in all fields");
      return;
    }
    if (newPassword !== confirmPassword) {
      ToastMsg("error", "Passwords do not match");
      return;
    }
    if (newPassword.length < 6) {
      ToastMsg("error", "Password must be at least 6 characters");
      return;
    }

    setLoading(true);
    ChangePasswordApi(
      { newPassword, confirmPassword },
      authtoken,
      id,
      email,
      (data) => {
        setLoading(false);
        ToastMsg("success", data.message);
        navigate("/PasswordSuccess", { state: { user_name: data.user_name } });
      },
      (error) => {
        setLoading(false);
        ToastMsg("error", error);
      }
    );
  };

  return (
    <div className="h-screen flex items-center justify-center relative bg-gray-50 font-sans">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-[url('https://media.istockphoto.com/id/1462401298/photo/reset-password-successful-concept-lock-icon-security-code-showing-on-change-password-page-on.jpg?s=1024x1024&w=is&k=20&c=PN0bXj7Hfc0zncGaFYQGYjKbsc4gibWHaD0Hf5Nl0pE=')]
        bg-cover bg-center opacity-10"
      ></div>
      <div className="absolute inset-0 bg-white/40 backdrop-blur-sm"></div>

      {/* Card */}
      <div className="w-full max-w-sm relative z-10">
        {/* Logo */}
        <div className="flex justify-center mb-6">
          <img
            src={ImagePaths.loginLogo.default}
            alt="App Logo"
            className="h-10 w-auto animate-fadeIn"
          />
        </div>

        <div className="bg-white/90 backdrop-blur-md rounded-xl shadow-xl p-6 animate-fadeIn">
          {/* Header */}
          <div className="flex items-center mb-4">
            <img
              src={ImagePaths.backArrow.default}
              alt="Back"
              className="h-5 w-5 cursor-pointer mr-2"
              onClick={() =>
                navigate("/otpverification", { state: { id, email } })
              }
            />
            <h2 className="text-lg font-semibold text-gray-800">
              Reset Your Password
            </h2>
          </div>
          <p className="text-[13px] text-gray-500 text-center mb-5">
            Set a new password for your account
          </p>

          {/* Username (Read only) */}
          <div className="mb-4">
            <input
              type="text"
              value={user_name}
              readOnly
              className="w-full px-3 py-2 text-sm border-b border-gray-300 outline-none bg-transparent"
              placeholder="Username"
            />
          </div>

          {/* New Password */}
          <div className="mb-4">
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              autoComplete="new-password"
              className="w-full px-3 py-2 text-sm border-b border-gray-300 outline-none bg-transparent"
              placeholder="New Password"
            />
          </div>

          {/* Confirm Password */}
          <div className="mb-6">
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              autoComplete="new-password"
              className="w-full px-3 py-2 text-sm border-b border-gray-300 outline-none bg-transparent"
              placeholder="Re-enter Password"
            />
          </div>

          {/* Submit Button */}
          <button
            onClick={onSubmit}
            disabled={loading || !newPassword || !confirmPassword}
            className={`w-full py-2 px-4 rounded-lg text-white font-semibold transition ${
              loading || !newPassword || !confirmPassword
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-[#04b7b1] hover:bg-[#04b7b1]/80 focus:ring-2 focus:ring-[#04b7b1] focus:ring-offset-2"
            }`}
          >
            {loading ? "Resetting Password..." : "Reset Password"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
